import { render, staticRenderFns } from "./video-list.vue?vue&type=template&id=7977d52c&scoped=true&"
import script from "./video-list.vue?vue&type=script&lang=js&"
export * from "./video-list.vue?vue&type=script&lang=js&"
import style0 from "./video-list.vue?vue&type=style&index=0&id=7977d52c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977d52c",
  null
  
)

export default component.exports